import { render } from "./DocumentReportExports.vue?vue&type=template&id=0cb6d627&scoped=true&ts=true"
import script from "./DocumentReportExports.vue?vue&type=script&lang=ts"
export * from "./DocumentReportExports.vue?vue&type=script&lang=ts"

import "./DocumentReportExports.vue?vue&type=style&index=0&id=0cb6d627&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb6d627"]])

export default __exports__